/**
 * Улучшения для боёвки
 * Интегрирует улучшенные анимации и визуальные эффекты
 */

import { createEnhancedAnimationsManager } from './enhancedAnimations.js';

/**
 * Создает менеджер улучшений боя
 */
export function createBattleEnhancementsManager({
  getBattleState,
  getPanelById
}) {
  const animations = createEnhancedAnimationsManager();
  
  /**
   * Улучшенный показ урона
   */
  function showDamage(creatureId, damage, isCrit = false) {
    const element = document.querySelector(`[data-panel-id="${creatureId}"]`);
    if (!element) return;
    
    // Shake эффект
    animations.shakeElement(element, isCrit ? 15 : 10, isCrit ? 400 : 300);
    
    // Эффект критического удара
    if (isCrit) {
      animations.showCritEffect(element);
    }
    
    // Улучшенная анимация урона
    animations.showEnhancedDamage(element, damage, isCrit, {
      offsetY: -20,
      color: isCrit ? '#ff0000' : '#ff6b6b',
      size: isCrit ? 28 : 20
    });
    
    // Анимация HP бара
    const hpBar = element.querySelector('.battle-hp-fill');
    if (hpBar) {
      const currentWidth = parseFloat(hpBar.style.width) || 100;
      const panel = getPanelById(getBattleState()?.panels || [], creatureId);
      if (panel) {
        const maxHp = panel.maxHp || 100;
        const currentHp = (panel.hp || maxHp) - damage;
        const newPercent = Math.max(0, Math.min(100, (currentHp / maxHp) * 100));
        animations.animateHPBar(hpBar, currentWidth, newPercent);
      }
    }
  }
  
  /**
   * Показ восстановления HP
   */
  function showHeal(creatureId, healAmount) {
    const element = document.querySelector(`[data-panel-id="${creatureId}"]`);
    if (!element) return;
    
    animations.animateHeal(element, healAmount);
    
    // Анимация HP бара
    const hpBar = element.querySelector('.battle-hp-fill');
    if (hpBar) {
      const currentWidth = parseFloat(hpBar.style.width) || 0;
      const panel = getPanelById(getBattleState()?.panels || [], creatureId);
      if (panel) {
        const maxHp = panel.maxHp || 100;
        const currentHp = Math.min(maxHp, (panel.hp || 0) + healAmount);
        const newPercent = Math.max(0, Math.min(100, (currentHp / maxHp) * 100));
        animations.animateHPBar(hpBar, currentWidth, newPercent);
      }
    }
  }
  
  /**
   * Показ применения статуса
   */
  function showStatusApply(creatureId, statusIcon, statusName) {
    const element = document.querySelector(`[data-panel-id="${creatureId}"]`);
    if (!element) return;
    
    animations.animateStatusApply(element, statusIcon, statusName);
  }
  
  /**
   * Показ эффекта победы
   */
  function showVictory() {
    const container = document.getElementById('battle-modal');
    animations.showVictoryEffect(container);
  }
  
  /**
   * Улучшенная анимация способности
   */
  function animateAbility(creatureId, abilityType) {
    const element = document.querySelector(`[data-panel-id="${creatureId}"]`);
    if (!element) return;
    
    // Разные эффекты для разных типов способностей
    switch (abilityType) {
      case 'heal':
        element.style.boxShadow = '0 0 20px #22c55e';
        setTimeout(() => {
          element.style.boxShadow = '';
        }, 500);
        break;
      case 'buff':
        element.style.boxShadow = '0 0 20px #3b82f6';
        setTimeout(() => {
          element.style.boxShadow = '';
        }, 500);
        break;
      case 'debuff':
        element.style.boxShadow = '0 0 20px #ef4444';
        setTimeout(() => {
          element.style.boxShadow = '';
        }, 500);
        break;
      default:
        element.style.boxShadow = '0 0 20px #fbbf24';
        setTimeout(() => {
          element.style.boxShadow = '';
        }, 500);
    }
  }
  
  return {
    showDamage,
    showHeal,
    showStatusApply,
    showVictory,
    animateAbility
  };
}





